<rask-container-block [noBorder]="true">
    <rask-header size="2">
        <label>
            Kundinformation
        </label>
        <rask-action-button
            (click)="searchClick()"
            icon="fas fa-search"
            aid="buttonSearchKund">
            Sök via kundregister
        </rask-action-button>
    </rask-header>

    @if(kund$ | async; as kund){
    <rask-list [data]="[kund.kund]">
        <rask-list-column header="Kund" field="namn" width="11%"></rask-list-column>
        <rask-list-column header="Person/orgnummer" field="personOrgnummer" width="10%"></rask-list-column>
        <rask-list-column header="Kundnr" field="kundnummer" width="10%"></rask-list-column>
        <rask-list-column header="Adress" field="postadress" width="10%"></rask-list-column>
        <rask-list-column header="Kontaktperson" field="kontaktperson" width="10%">
            <ng-template let-row="row">
                <rask-simple-selector
                    class="kontaktperson-selector"
                    [formControl]="kontaktpersonControl"
                    [values]="kund.kontaktpersoner"
                    bindLabel="namn"
                    bindValue="id">
                </rask-simple-selector>
            </ng-template>
        </rask-list-column>
        <rask-list-column header="Telefon" field="telefon" width="10%">
            <ng-template let-row="row">
                @if(kund.kontaktperson){
                {{kund.kontaktperson.telefon}}
                }
            </ng-template>
        </rask-list-column>
        <rask-list-column header="E-Postadress" field="epost" width="10%">
            <ng-template let-row="row">
                @if(kund.kontaktperson){
                {{kund.kontaktperson.model.epost}}
                }
            </ng-template>
        </rask-list-column>
    </rask-list>
    }
</rask-container-block>